module.exports = __webpack_public_path__ + "img/member.d96b2f24.png";